import { render, staticRenderFns } from "./simDataPause.vue?vue&type=template&id=1ab133f4&scoped=true&"
import script from "./simDataPause.vue?vue&type=script&lang=js&"
export * from "./simDataPause.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ab133f4",
  null
  
)

export default component.exports